import React from 'react';
import { Skeleton } from 'antd';

import PersonalDataForm from '@/components/Settings/Account/PersonalDataForm';
import CredentialsForm from '@/components/Settings/Account/CredentialsForm';

import './style.less';
import {
  useChangePassword,
  useUpdateUser,
  useUser,
} from '@/core/domain/enterprise/Users/Users.hooks';
import { getUserFromLocalStorage } from '@/utils/user';
import {
  UpdateUserRequest,
  UserChangePasswordRequest,
} from '@/core/domain/enterprise/Users/Users.types';
import { USER_ID } from '@/utils/user/constants';

const AccountPage = () => {
  const { userId } = getUserFromLocalStorage();

  const accountMutation = useChangePassword();

  const updateUserMutation = useUpdateUser();

  const { data, isFetching } = useUser(Number(userId));

  const handlePersonalDataSubmit = async (values: UpdateUserRequest) => {
    try {
      if (data) {
        const obj: UpdateUserRequest = {
          ...values,
          profilesId: data?.profiles.map((p) => p.id),
          id: data.id,
        };

        await updateUserMutation.mutateAsync(obj);
      }
    } catch {}
  };

  const handleAccountDataSubmit = async (values: UserChangePasswordRequest) => {
    try {
      const idUser = localStorage.getItem(USER_ID);
      await accountMutation.mutateAsync({ ...values, idUser: Number(idUser) });
    } catch {}
  };

  return (
    <div className="page account-page-wrapper">
      <Skeleton
        active
        loading={
          updateUserMutation.isLoading ||
          accountMutation.isLoading ||
          isFetching
        }
      >
        <PersonalDataForm
          initialValues={data}
          onSubmit={handlePersonalDataSubmit}
        />

        <CredentialsForm onSubmit={handleAccountDataSubmit} />
      </Skeleton>
    </div>
  );
};

export default AccountPage;
